export enum Role {
  SYSTEMADMIN = 'SYSTEMADMIN',
  USER = 'USER',
  SYSTEMSUPPORT = 'SYSTEMSUPPORT',
}
